import { render, staticRenderFns } from "./BasePageLayout.vue?vue&type=template&id=2833fffe&scoped=true&"
import script from "./BasePageLayout.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BasePageLayout.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BasePageLayout.vue?vue&type=style&index=0&id=2833fffe&prod&scoped=true&lang=scss&"
import style1 from "./BasePageLayout.vue?vue&type=style&index=1&id=2833fffe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833fffe",
  null
  
)

export default component.exports